<div #summary class="company-summary" (click)="onClick()">
	<div class="content">
		<div class="text">
			@if(isNew && !featureSwitches.enableShowCompanyLogos){

			<div class="new-company-indicator nologo">
				{{ Loc(LocalizedTextIds.New) }}
			</div>
			}
			<div class="company-name">
				<div>{{ company.name }}</div>
				<company-status-icon
					[statuses]="company.statuses"
					tooltipTop="-32px"
					tooltipLeft="88px"
				>
				</company-status-icon>
			</div>
			@if(featureSwitches.enableShowLocationStatus){
			<company-location-status
				class="location"
				[company]="company"
			></company-location-status
			>} @if(company.assets?.length > 0) {
			<div class="asset-count">
				{{ assetCountLabel }}
			</div>
			}
			<div class="description">
				{{ company.description }}
			</div>
		</div>

		<div class="outer">
			<div class="logo">
				<company-logo
					[company]="company"
					[size]="logoSize"
				></company-logo>
				@if(isNew && featureSwitches.enableShowCompanyLogos){
				<div class="new-company-indicator">
					{{ Loc(LocalizedTextIds.New) }}
				</div>
				}
			</div>
		</div>
	</div>

	@if(featureSwitches.enableShowTags){
	<tags
		[ngClass]="tagsToDisplay.length > 0 ? 'tags' : ['tags', 'empty']"
		[targetIdentifier]="encodedName"
		[tags]="tagsToDisplay"
	>
	</tags>
	}
</div>
